import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// Define a type for the slice state

// Define the initial state using that type

const leaveEligibilitySlice = createSlice({
  name: "leaveEligibility",

  initialState: { leaveEligibility: [], refreshLeaveEligibility: false },
  reducers: {
    setLeaveEligibility: (state: any, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.leaveEligibility = payload;
    },
    setRefreshLeaveEligibility: (state: any, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.refreshLeaveEligibility = payload;
    },
    resetLeaveEligibility: (state) => {
      state.leaveEligibility = [];
    },
  },
});

export const {
  setLeaveEligibility,
  resetLeaveEligibility,
  setRefreshLeaveEligibility,
} = leaveEligibilitySlice.actions;

// // Other code such as selectors can use the imported `RootState` type
// export const selectCount = (state: RootState) => state.counter.value

export default leaveEligibilitySlice.reducer;
